export const ApiErrorCode = Object.freeze({
  NoPermission: 'NoPermission',
  IllegalArgument: 'IllegalArgument',
  GeneralReject: 'GeneralReject',
  TooManyRequests: 'TooManyRequests',
  Forbidden: 'Forbidden',
  TapdApiFailed: 'TapdApiFailed',
  TapdBugNotInWorkspace: 'TapdBugNotInWorkspace',
});
